import { render } from "./register.vue?vue&type=template&id=05210ae3&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=05210ae3&lang=scss&scoped=true"

import exportComponent from "/Users/jinjing/Desktop/jj/code1/HM0518/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05210ae3"]])

export default __exports__